//青矩洞察
import React from 'react';
import '../CompanyNews.scss';
import { Link } from 'react-router-dom'
import { policyStudy} from '@/fetch'
class Policy extends React.PureComponent {
    constructor () {
        super()
        this.state = {
            policyStudydata:[],
            off_on:false,
        }
        this.startx = null;                 //触摸起始点x轴坐标
        this.starty = null;                 //触摸起始点y轴坐标
        this.size = 1;
    }
    componentWillMount () {
        let that = this;
        policyStudy.getPolicyStudyByCondition({ page: that.size, size:10 }).then(res => {
            if(JSON.stringify(res.page.content) !== '[]'){
                that.setState({policyStudydata: that.state.policyStudydata.concat(res.page.content)}, ()=> {});
                that.setState({off_on:true})
                that.forceUpdate();
            }else{
                that.setState({off_on:false})
            }
        }).catch(err => console.log(err))
    }
    getAngle(angx, angy) {
        return Math.atan2(angy, angx) * 180 / Math.PI;
    };

    //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
    getDirection(startx, starty, endx, endy) {
        var angx = endx - startx;
        var angy = endy - starty;
        var result = 0;

        //如果滑动距离太短
        if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
            return result;
        }

        var angle = this.getAngle(angx, angy);
        if (angle >= -135 && angle <= -45) {
            result = 1;
        } else if (angle > 45 && angle < 135) {
            result = 2;
        } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
            result = 3;
        } else if (angle >= -45 && angle <= 45) {
            result = 4;
        }

        return result;
    }
    touchStart (e) {
        e.preventDefault();
        this.startx = e.touches[0].pageX;
        this.starty = e.touches[0].pageY;
    }
    touchEnd (e) {
        let that = this;
        var endx, endy;
        endx = e.changedTouches[0].pageX;
        endy = e.changedTouches[0].pageY;
        var direction = this.getDirection(this.startx, this.starty, endx, endy);
        switch (direction) {
            // case 0:
            //     console.log('没动')
            //     break;
            case 1:
                    if (that.state.off_on) {
                        that.state.off_on = false;
                        that.size++;
                        // console.log("第"+page+"页");
                        policyStudy.getPolicyStudyByCondition({ page: that.size, size:10 }).then(res => {
                            if(JSON.stringify(res.page.content) !== '[]'){
                                that.setState({policyStudydata: that.state.policyStudydata.concat(res.page.content)}, ()=> {});
                                that.setState({off_on:true})
                                that.forceUpdate();
                            }else{
                                that.setState({off_on:false})
                            }
                        }).catch(err => console.log(err))
                    }
                break;
            // case 2:
            //     console.log('下')
            //     break;
            // case 3:
            //     console.log('左')
            //     break;
            // case 4:
            //     console.log('又')
                // break;
            default:
        }

    }
  render() {
    return ( <div className = 'Policy' onTouchStart={this.touchStart.bind(this)} onTouchEnd={this.touchEnd.bind(this)}>
                  <main className = "CompanyNews-body" >
                               {
                        this.state.policyStudydata.map((item, index) =>
                        <Link to={'/News/Policy/NewsDetail/' + item.id} key={index}>
                             <dt>
                                <img  src={item.accessPath} width="100%" height="100%" alt=""/>
                              </dt>
                            <dd>
                                <h4>{item.title.length < 20
                                ? item.title
                                : item.title.substring(0, 20) + '...'}</h4>
                                <p>{item.publishAt.split(' ')[0]} {item.source.length < 5? item.source : item.source.substring(0, 5) + '...'}</p>
                            </dd>
                        </Link>
                        )
                    }
                </main>
            </div>
    )
  }
}
export default Policy;
